<template>
    <div v-cloak >
        <van-dialog v-model="is_show" title="最新官方公众号" :show-confirm-button="false" confirm-button-text="关闭" :closeOnClickOverlay="true">
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
                <div style="font-size: 20px;color: #ee0a24;margin-top: 30px;width: 70%">解锁微信支付、点券支付、消息订阅等全部功能</div>
                <van-image style="margin: 30px 0 10px 0" width="200px" height="200px" fit="contain" :src="westore.state.app.systemInfo.antilost.official_qrcode"/>
                <div style="font-size: 12px;font-weight: bold;color: #2e2e2e;margin-bottom: 40px">扫码关注或微信搜索{{westore.state.app.systemInfo.antilost.official_name}}</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    export default {
        name: "AntiLostDialog",
        props:{
        },
        data() {
            return {
                is_show: false,
            };
        },
        methods:{
            show(){
                this.is_show = true
            },
            close(){
                this.is_show = false
            }
        }
    }
</script>

<style scoped lang="less">
</style>
